import { Injectable, inject, Injector } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {catchError, concatMap, map, switchMap, withLatestFrom} from 'rxjs/operators';
import { DeviceSharingActionTypes, DeviceSharingActions } from '../actions/device-sharing.actions';
import * as fromStore from '../../../store';
import * as featureActions from '../../index';
import { DevicesService } from '../../../services/devices.service';
import { UpdateInfoModel } from '../../updateInfo/update-info.model';
import { updateInfoType } from '../../../shareModel';
import {TranslateService} from '@ngx-translate/core';

@Injectable()
export class DeviceSharingEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private DeviceService = inject(DevicesService);
  private injector = inject(Injector);


  constructor() {}

  getDeviceShareList$ = createEffect(() => this.actions$.pipe(
    ofType(DeviceSharingActionTypes.GetDeviceSharingList),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const payload = { ...(action?.payload ?? {}) };
      const params = {
        otp: user.otp,
        owner_acode: null,
        dcode: null,
        shared_acode: null,
        RegionIds: null
      };
      if (payload.owner_acode) { params.owner_acode = payload.owner_acode; }
      if (payload.dcode) { params.dcode = payload.dcode; }
      if (payload.shared_acode) { params.shared_acode = payload.shared_acode; }
      if (payload.RegionIds) { params.RegionIds = Array.isArray(payload.RegionIds) ? [...payload.RegionIds] : payload.RegionIds; }
      return this.DeviceService.ReadDeviceShareInfo(params).pipe(
        switchMap((res) => {
          if (res.result && res.msg.body) {
            const result = Array.isArray(res.msg.body) ? res.msg.body : [];
            return [new featureActions.LoadDeviceSharingList(result)];
          } else {
            return [new featureActions.GetDeviceSharingListFail()];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          return [new featureActions.GetDeviceSharingListFail()];
        })
      );
    })
  ));
  AddDeviceShareList$ = createEffect(() => this.actions$.pipe(
    ofType(DeviceSharingActionTypes.AddDeviceSharing),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const payload = { ...(action?.payload ?? {}) };
      const param = {
        otp: user.otp,
        dcode: payload.objectId,
        owner_acode: user.acode,
        shared_user: payload.shared_user
      };
      return this.DeviceService.AddDeviceShareInfo(param).pipe(
        switchMap((res) => {
          const updateRes: UpdateInfoModel = {
            result: false,
            msg: '',
            errmsg: 'Error',
            type: updateInfoType.AddDeviceSharingInfo
          };
          if (res.Flag) {
            return [new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: true, msg: this.injector.get(TranslateService).instant('Update Success') })];
          } else {
            return [new featureActions.UpdateInfoFailAction(updateRes)];
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.AddDeviceSharingInfo
          };
          return [new featureActions.UpdateInfoFailAction(res)];
        })
      );
    })
  ));
  UpdateDeviceShareList$ = createEffect(() => this.actions$.pipe(
    ofType(DeviceSharingActionTypes.UpdateDeviceSharing),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const payload = { ...(action?.payload ?? {}) };
      const params = {
        otp: user.otp,
        share_id: payload.share_id,
        is_confirm: payload.is_confirm,
        owner_acode: payload.owner_acode
      };
      return this.DeviceService.UpdateDeviceShareInfo(params).pipe(
        switchMap((res) => {
          const updateRes: UpdateInfoModel = {
            result: false,
            msg: '',
            errmsg: 'Error',
            type: updateInfoType.UpdateDeviceSharingInfo
          };
          if (res.Flag) {
            return [new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: true, msg: this.injector.get(TranslateService).instant('Update Success') })];
          } else {
            return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: this.injector.get(TranslateService).instant('Update Failed') })];
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.UpdateDeviceSharingInfo
          };
          return [new featureActions.UpdateInfoFailAction(res)];
        })
      );
    })
  ));
  DeleteDeviceShareList$ = createEffect(() => this.actions$.pipe(
    ofType(DeviceSharingActionTypes.DeleteDeviceSharing),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const payload = { ...(action?.payload ?? {}) };
      const params = {
        otp: user.otp,
        share_id: payload.share_id,
        owner_acode: payload.owner_acode,
        dcode: payload.objectId
      };
      return this.DeviceService.DeleteDeviceShareInfo(params).pipe(
        switchMap((res) => {
          const updateRes: UpdateInfoModel = {
            result: false,
            msg: '',
            errmsg: 'Error',
            type: updateInfoType.DeleteDeviceSharingInfo
          };
          if (res.Flag) {
            return [new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: true, msg: this.injector.get(TranslateService).instant('Update Success') })];
          } else {
            return [new featureActions.UpdateInfoFailAction(updateRes)];
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.DeleteDeviceSharingInfo
          };
          return [new featureActions.UpdateInfoFailAction(res)];
        })
      );
    })
  ));
}
